var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDefaultImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 68,
    viewBox: "0 0 84 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M4.22176 67.2888H80.7079C82.4506 67.2888 83.9997 65.9334 83.9997 64.1907C83.9997 63.4161 83.8061 62.8352 83.4188 62.2543L72.7688 47.9253C71.8007 46.3762 69.6707 46.1825 68.1216 47.1507C67.9279 47.1507 67.9279 47.3444 67.7343 47.538L56.8907 57.8007L31.718 23.7208C30.5562 22.1717 28.6199 21.9781 27.0708 22.9462C26.6835 23.1399 26.4899 23.5272 26.2962 23.7208L1.12359 62.2543C0.542682 63.6098 0.929954 65.7398 2.47904 66.7079C3.05995 67.0952 3.64086 67.2888 4.22176 67.2888Z",
    fill: "#0078FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M66.3786 23.7201C72.6882 23.7201 77.8031 18.6052 77.8031 12.2956C77.8031 5.98602 72.6882 0.871094 66.3786 0.871094C60.069 0.871094 54.9541 5.98602 54.9541 12.2956C54.9541 18.6052 60.069 23.7201 66.3786 23.7201Z",
    fill: "#0078FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultImage);
export default __webpack_public_path__ + "static/media/default-image.98bd4cc9953d1a4744f972727e805833.svg";
export { ForwardRef as ReactComponent };